import { partial } from '../../../util/translation/translation';
import { validateParticipantPayment } from '../payments';

const p = partial('validateErrors.participantFormErrors');
const validateParticipants = (values) => {
  const errors = {};

  if (!values.selectedCompany && values?.selectedUser?.hasCompany) {
    errors.selectedCompany = p('companyFieldCantBeEmpty');
  }

  if (!values.owner && !values.firstName) {
    errors.owner = p('userFieldCantBeEmpty');
  }

  if (!values.firstName) {
    errors.firstName = p('firstNameFieldCantBeEmpty');
  }

  if (!values.lastName) {
    errors.lastName = p('lastNameFieldCantBeEmpty');
  }
  // Paid events: how they pay
  validateParticipantPayment(values, errors);
  return errors;
};

export default validateParticipants;
